var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function PencilIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5848 2.58922L21.4186 5.423C22.1997 6.20404 22.2006 7.46943 21.42 8.25007L8.02248 21.6475C7.82781 21.8422 7.44773 22 7.16682 22H3.00063C2.448 22 2 21.5552 2 20.9995V16.8338C2 16.556 2.16011 16.1708 2.35267 15.9784L15.757 2.58722C16.5378 1.80728 17.8037 1.80806 18.5848 2.58922ZM4.00051 17.1537L4.00199 18.0915C4.5268 17.9116 5.13151 18.031 5.55025 18.4498C5.97081 18.8703 6.08944 19.4785 5.90612 20.0049L6.83434 20.0073L8.38525 18.4563L5.54284 15.6139L4.00051 17.1537ZM18.0057 8.83585L15.1706 6.00343C15.1706 6.00343 10.2674 10.8974 6.95825 14.2009L9.79947 17.0421L18.0057 8.83585Z", fill: "" })));
}
export var PencilIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: PencilIconInner }, props))); };
//# sourceMappingURL=PencilIcon.js.map